import React from "react";

import { FormattedMessage, injectIntl } from "react-intl";

import Autocomplete from '@material-ui/lab/Autocomplete';

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";
import { Figure } from "react-bootstrap";


import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';


import { createJobRequest,getMenus,getJobServiceTypes,getLabAccounts,getLocations,getMaster,getAccountDetails} from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';


import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';








const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    root: {
      display: 'flex',
    },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
     // margin: theme.spacing(1),
      minWidth: 120,
    },
};





class CreateJobRequest extends React.Component {
  state = {
    fields:[],
    users:[],
    roles:[],
    accounts:[],
    selectedVal:[],
     selectedPlan:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    pentity:{},
    tasktypes:[],
    permission:[],
    assignees:[],
    selectedUsers:[],
    locations:[],
    jobServiceTypes:[],
    jobServiceTypeId:[],
    deliveryDate:null,
    implants:[],
fieldGroups:null,
treatmentPlans:[],
  }





constructor(props)
{
  super(props);
  var date = new Date();

  if (this.props.location!=null && this.props.location.data!=null)  
  {
      console.log(this.props.location.data);
  }
  else if(props.pentities!=null)
  {
    console.log(props.pentities);
  }

  let pentity = {};
  if (this.props.location!=null && this.props.location.data!=null) 
  {
    pentity = this.props.location.data.pEntity[0];
  }
  else if(props.pentities!=null)
  {
     pentity = props.pentities[0];
  }
  else if(props.pentity!=null)
  {
    pentity = props.pentity;
  }

    this.state = {
      menu: false,
      fields:[],
      roles:[],
      users:[],
      selectedVal:[],
      accounts:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      pentity: pentity,
      schdate: date,
      tasktypes:[],
      permission:[],
      selectedUsers:[],
      locations:[],
      jobServiceTypes:[],
      jobServiceTypeId:[],
      assignedToAccountKey:null,
      deliveryDate:null,
      implants:[],
      treatmentPlans:[],
      selectedPlan:[],
       selTreatmentPlans:[],
      fieldGroups: [
      {
        "fieldName": "extractions1",
        "displayName": "Top",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "top",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16"
        ],
        "items": null,
        "imagePath": [
          "media/misc/etop1.png",
          "media/misc/etop2.png",
          "media/misc/etop3.png",
          "media/misc/etop4.png",
          "media/misc/etop5.png",
          "media/misc/etop6.png",
          "media/misc/etop7.png",
          "media/misc/etop8.png",
          "media/misc/etop9.png",
          "media/misc/etop10.png",
          "media/misc/etop11.png",
          "media/misc/etop12.png",
          "media/misc/etop13.png",
          "media/misc/etop14.png",
          "media/misc/etop15.png",
          "media/misc/etop16.png"
        ],
        "lookUp": null
      },
      {
        "fieldName": "extractions2",
        "displayName": "Bottom",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "bottom",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "32",
          "31",
          "30",
          "29",
          "28",
          "27",
          "26",
          "25",
          "24",
          "23",
          "22",
          "21",
          "20",
          "19",
          "18",
          "17"
        ],
        "items": null,
        "imagePath": [
          "media/misc/ebottom32.png",
          "media/misc/ebottom31.png",
          "media/misc/ebottom30.png",
          "media/misc/ebottom29.png",
          "media/misc/ebottom28.png",
          "media/misc/ebottom27.png",
          "media/misc/ebottom26.png",
          "media/misc/ebottom25.png",
          "media/misc/ebottom24.png",
          "media/misc/ebottom23.png",
          "media/misc/ebottom22.png",
          "media/misc/ebottom21.png",
          "media/misc/ebottom20.png",
          "media/misc/ebottom19.png",
          "media/misc/ebottom18.png",
          "media/misc/ebottom17.png"
        ],
        "lookUp": null
      }
    ]
  

    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}

onSelectTag=(e, value)=> {
console.log("implant:::",value);
let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.implantTypeKey)
      ))
    console.log(tguser);
    this.setState({implantTypes:tguser});
  }
}


onSelectPlan=(e, value)=> {
console.log("trearment plan:::",value);
let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.treatmentPlanKey)
      ))
    console.log(tguser);
    this.setState({selTreatmentPlans:tguser});
  }
}

handleServiceChange = event => {

	console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
	//console.log(event);
	let chk = this.state.jobServiceTypeId;
	let chkvalue=[];
	if(chk!=null)
	{
		chk.push(event.currentTarget.value);
	}
	else
	{
		chk = [event.currentTarget.value];
	}
	this.setState({
		jobServiceTypeId : chk
	})
  //console.log("checkbox::::::",chk);
}


 handleAccountChange = async (event,newValue) =>
  {
       console.log("account chnage::::",event,newValue);
       if(newValue!=null && newValue.accountId!=null)
       {
          this.setState({assignedToAccountKey:newValue.accountId});
       
       }
 
  }

  handleCheckBoxChange = event => {

	console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
	//console.log(event);
	let chk = this.state[event.currentTarget.name];
	let chkvalue=[];
	if(chk!=null)
	{
		chk.push(event.currentTarget.value);
	}
	else
	{
		chk = [event.currentTarget.value];
	}
	this.setState({
		[event.currentTarget.name] : chk
	})
}



  toggleMenu()
  {
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    getLabAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts: data })
      //console.log(this.state.users)
     })

     getJobServiceTypes().then(response => response.data)
     .then((data) => {
       this.setState({jobServiceTypes: data })
       //console.log(this.state.users)
      })

       getMaster("implant").then(response => response.data)
          .then((data) => {
            this.setState({ implants: data })
            //console.log(this.state.users)
           })

            getMaster("treatmentplan").then(response => response.data)
          .then((data) => {
            this.setState({ treatmentPlans: data })
            //console.log(this.state.users)
           })

             getAccountDetails().then(response => response.data)
             .then((data) => {
                  console.log("account details::::"+data);
                     getLocations(1,100,'locationName','asc',{accountKey:data.accountId})
                      .then((response) => {
                        //this.setState({ locations:response.data})
                        this.setState({locations:response.data});
                        //console.log("locations:::::",response.data);
                        });

                  });

     
     
    

     getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     })
  }

 
  
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
    }

    
  
} 



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
     const pentity = this.state.pentity;
     console.log("props:::::",);
     

    return (
      <>
          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
           {!this.state.status && 
          <Formik
                  initialValues={{
                    accountId:"",
                    pEntityId:"",
                    notes:"",
                    patientName: this.state.pentity.firstName + " " + this.state.pentity.lastName,
                    pId: this.state.pentity.patientId,
                    dob: this.state.pentity.dateOfBirth
                 }}
                  validate={values => {
                    const errors = {};

                    console.log("formik va::::::",this.state.jobServiceTypeId,this.state.assignedToAccountKey);

                    if (this.state.jobServiceTypeId.length===0) {
                      errors.jobServiceTypeId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    //else
                    //  errors.jobServiceTypeId = false;
                  

                
                    if (this.state.assignedToAccountKey===null ) {
                      errors.assignedToAccountKey = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (this.state.deliveryDate===null ) {
                      errors.deliveryDate = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    //else
                    //errors.assignedToAccountKey = false;

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {

                   this.setState({loading:true});
                 

                          createJobRequest(
                            this.state.assignedToAccountKey,
                            this.state.pentity.pEntityId,
                            values.notes,
                            this.state.jobServiceTypeId,                   
                            this.state.deliveryDate,
                            values.locationKey,
                            this.state.extractionTop,
                            this.state.extractionBottom,
                            this.state.selTreatmentPlans,
                            this.state.implantTypes
                          )
                            .then(resp => {
                              setSubmitting(false);
                              let mes ='Your job order has been placed successfully.You can track your orders under menus->Digital Planning Module. You will be notified by the lab about the process.';
                              
                              //mes = mes + " Job noification has been sent to "+resp.data.split('|')[1] + ".";
                                this.setState({status:true,isSubmitting:false,loading:false,
                                statusMessage:mes ,selectedUsers:[],tguser:[],
                                alertType:'alert-success',statusColor:'alert-success'});
                                window.scrollTo(0,0);
                             
                           
                            
                            
                            })
                            .catch(() => {
                              setSubmitting(false);
                              this.setState({loading:false,isSubmitting:false});
                            })
                          

                   
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
    
          <div className="kt-section">
            <div className="kt-section__content">
            
            <div className="row">
                        <div className="col">
                          <TextField
                            margin="normal"
                            label="Patient Name"
                            className="kt-width-full"
                            name="patientName"
                            value={values.patientName}
                            InputProps={{
                              readOnly: true,
                            }}
                            variant="filled"
                            
                          />
                        </div>
                      </div>    

                      <div className="row">
                        <div className="col">
                          <TextField
                            margin="normal"
                            label="PID"
                            className="kt-width-full"
                            name="pId"
                            value={values.pId}
                            InputProps={{
                              readOnly: true,
                            }}
                            variant="filled"
                          />
                        </div>
                      </div>    

                      <div className="row">
                        <div className="col">
                          <TextField
                            margin="normal"
                            label="DOB"
                            className="kt-width-full"
                            name="dob"
                            value={values.dob}
                            InputProps={{
                              readOnly: true,
                            }}
                            variant="filled"
                          />
                        </div>
                      </div>    
         
             
                      <div className="row">
                       <div className="col">
                        <FormControl component="fieldset" className={classes.root} style={{'width':'100%'}}>
                          <FormLabel component="legend">Digital Planning Packages</FormLabel>
                           <FormGroup row={true}>
                              {this.state.jobServiceTypes.map((pt)=>(
                              <>
                              <FormControlLabel 
                                control={<Checkbox tyle={{ width: 'auto' }}  onChange={this.handleServiceChange} value={pt.jobServiceTypeId} name={'jobServiceTypeId'} color="primary"/>}
                                label={pt.serviceType}
                                
                              />
                              </>
                                                                
                              ))}
                           </FormGroup>
                           {Boolean(errors.jobServiceTypeId) &&
                           <FormHelperText id="b-text" error>This field is required</FormHelperText>
                            }
                         </FormControl>
                         </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <Grid container justify="space-around">
                          <KeyboardDatePicker
                                variant="inline"
                                format="MM/dd/yyyy"
                                margin="normal"
                                id="deliveryDate"
                                name="deliveryDate"
                                label="Surgery Date"
                                minDate = {new Date()}
                                value={this.state.deliveryDate}
                                onChange={value => {
                                  this.setState({deliveryDate:value})
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                              />
                              
                          </Grid>
                           {Boolean(errors.deliveryDate) &&
                              <FormHelperText id="a-text" error>This field is required</FormHelperText>
                            }
                          </MuiPickersUtilsProvider>

                        </div>
                      </div>

                      <div className="row">
                        <div className="col">
                          <FormControl className={classes.formControl} style={{'width':'100%'}}>
                             <Autocomplete
                               
                                id="assignedToAccountKey"
                                name="assignedToAccountKey"
                                options={this.state.accounts}
                                onChange={(event,newValue)=>this.handleAccountChange(event,newValue)}
                                onBlur={handleBlur}
                                value={values.assignedToAccountKey}
                                helperText={errors.assignedToAccountKey}
                                error={Boolean(errors.assignedToAccountKey)}
                                variant="outlined"
                                autoComplete={true}
											          clearOnBlur={true}
                                getOptionLabel={(option) => option.accountName}
                                renderInput={(params) => (
                                                               <TextField
                                                               {...params}
                                                                   margin="normal"
                                                                   label="Assign to Lab"
                                                                  
                                                       />
                                                    )}
                                                   />
                            {Boolean(errors.jobServiceTypeId) &&
                              <FormHelperText id="a-text" error>This field is required</FormHelperText>
                            }
                         </FormControl>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                                       <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                                <InputLabel id="locationKey-label">Location</InputLabel>
                                                   <Select
                                                    labelId="locationKey-label"
                                                    id="locationKey"
                                                    margin="normal"
                                                    name="locationKey"
                                                    value={values.locationKey}
                                                    //onChange={(e)=>{handleChange(e);this.setState({locationKey:e.target.value})}}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    className="kt-width-full"
                                                    style={{'width':'100%'}}
                                                  >
                                                  <MenuItem value="">
                                                      <em>None</em>
                                                    </MenuItem>
                                                    {this.state.locations.map((loc) =>(
                      
                                                    <MenuItem key={loc.locationKey} value={loc.locationKey}>{loc.locationName}</MenuItem>
                                                    
                                                    ))}
                                                  </Select>
                                               </FormControl>
                                    </div>
                     </div>
                     <div className="row">
                        <div className="col">
                          <TextField
                            margin="normal"
                            label="Tooth # / Notes"
                            className="kt-width-full"
                            name="notes"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.notes}
                            helperText={touched.notes && errors.notes}
                            error={Boolean(touched.notes && errors.notes)}
                            variant="outlined"
                            multiline
                            maxRows={4}
                          />
                        </div>
                      </div>    
                      <div className="row">
                                       
                      <div className="col">
                                                <Autocomplete
                                                  multiple
                                                  id="tags-standard"
                                                  defaultValue={this.state.selectedVal}
                                                  options={this.state.implants}
                                                  onChange={this.onSelectTag}
                                                  style={{'width':'100%'}}
                                                  getOptionLabel={(option) => option.implantName }
                                                  renderInput={(params) => (
                                                            <TextField style={{'width':'100%'}}
                                                            {...params}
                                                    
                                                                                      margin="normal"
                                                                                      label="Implant Name"
                                                                                      
                                                                                    />
                      
                                                  )}
                                                />
                                     
                                    </div>
                                    </div>
                     {this.state.fieldGroups!=null && this.state.fieldGroups.map((field)=>(
                      <>
                      <div className="row">
                        <div className="col">
                          {field.dataType === "checkboxgroupimage" &&
                           
														        <div class="container" style={{'background-color':'#0B6CAF','width':'100%'}}>
														        {field.imagePosition === 'top' &&
														        <div className="row" style={{'border': '1px solid grey','width':'100%','background-color':field.background!==null && field.background=='white'? 'white':'#0B6CAF'}}>
														        <FormGroup row>
														          {field.imagePath.map((val,index)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'65px'}}>
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={val}
													              		/>}
													              	style={{'margin-left': 'auto','margin-right':'auto'}} />

                                         <FormControlLabel 
															            control={<Checkbox style={{'margin-left':'0px','color':'white'}} onChange={this.handleCheckBoxChange} value={field.values[index]} name={'extractionTop'} fontSize="small" />}
															            label={field.values[index]} labelPlacement="end"  style={{'color':'white'}}

															          />
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														        </div>
														    	}
														        {/*<div className="row" style={{'border': '1px solid grey'}}>
														        <FormGroup row >
														          {field.values.map((val)=>(
														          	<div className="col" style={{'border': '1px solid grey','width':'200px'}}>
													  		          <FormControlLabel 
															            control={<Checkbox style={{'margin-left':'0px','color':'white'}} onChange={this.handleCheckBoxChange} value={val} name={field.fieldName} fontSize="small" />}
															            label={val} labelPlacement="bottom"  style={{'margin-left':'0px','color':'white'}}

															          />
															          </div>
														         ))}
														        </FormGroup>
														        </div>*/}
														        {field.imagePosition === 'bottom' &&
														        <div className="row" style={{'border': '1px solid grey','width':'100%','background-color':field.background!==null && field.background=='white'? 'white':'#0B6CAF'}}>
														        <FormGroup row>
														          {field.imagePath.map((val,index)=>(
														          	<div className="col" style={{'border': '1px solid grey','alignContent':'center', 'text-align': 'center','width':'65px'}}>
                                         <FormControlLabel 
															            control={<Checkbox style={{'margin-left':'0px','color':'white'}} onChange={this.handleCheckBoxChange} value={field.values[index]} name={'extractionBottom'} fontSize="small" />}
															            label={field.values[index]} labelPlacement="end"  style={{'color':'white'}}

															          />

															        
														          	 <FormControlLabel 
															            control={<Figure.Image
										                	                alt="171x180"
															                src={val}
													              		/>}
													              	style={{'margin-left': 'auto','margin-right':'auto'}} />
													              		</div>
													              	
												  	          
														         ))}
														        </FormGroup>
														        </div>
														    	}

															
																

														        </div>
														        
													      
                          }
                        </div>
                      </div>
                      </>
                     ))
                      }

                       <div className="row">
                                       
                      <div className="col">
                                                <Autocomplete
                                                  multiple
                                                  id="tags-standard"
                                                  defaultValue={this.state.selectedPlan}
                                                  options={this.state.treatmentPlans}
                                                  onChange={this.onSelectPlan}
                                                  style={{'width':'100%'}}
                                                  getOptionLabel={(option) => option.treatmentPlanName }
                                                  renderInput={(params) => (
                                                            <TextField style={{'width':'100%'}}
                                                            {...params}
                                                    
                                                                                      margin="normal"
                                                                                      label="Treatment Recommendations"
                                                                                      
                                                                                    />
                      
                                                  )}
                                                />
                                     
                                    </div>
              
</div>
              
           
              <div className="row">
                <div className="col">
                    <button
                         disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                          Confirm & Order
                        </button>
                </div>
              </div>
           
              
              
        </div>
        </div>
        
   

        </form>
            )}
            </Formik>
          
          }

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(CreateJobRequest));

